import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PieChartConfig } from '../../../../../shared/google-chart/Models/PieChartConfig';

@Component({
	selector: 'app-high-temperature-alert',
	templateUrl: './high-temperature-alert.component.html',
	styleUrls: ['./high-temperature-alert.component.css']
})
export class HighTemperatureAlertComponent implements OnInit, OnChanges {

	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	config: PieChartConfig;
	tableColumns: any[] = [];
	title: string = 'High Temperature Alerts';
	elementId: string = 'batt_alert_high_temp';
	widgetClass: string = 'height-530';
	siteWidgetOptions: any = {
		hasDate: true,
		isAlertWidget: true
	};

	constructor() { }

	ngOnInit() {
	
		this.config = new PieChartConfig({
			colors: [
				{ color: '#109618' },
				{ color: '#bd2f26' },
			]
		});
		
		this.config.formatFunction = (data) => {
			let formattedData: any[] = [
				[
					{"label": "Name", "type": "string"},
					{"label": "Value", "type": "number"}
				]
			];

			formattedData.push([{v: "No Alerts"}, {v: data.Pie[0].ok}]);
			formattedData.push([{v: "1 HT or More"}, {v: data.Pie[1].one_or_more}]);
			return formattedData;
		};
	}
	
	ngOnChanges(changes) {
		if(this.data) {
			let tableColumns = [{title: "Battery ID", property: "battery_id"}];
			if (this.data.siteSettings.userSettings.view_truck_id) {
				tableColumns.push({title: "Truck ID", property: "truck_id"});
			}
			tableColumns.push({title: "Max Temp Recorded", property: "max_temp"});
			tableColumns.push({title: "Days of High Temp", property: "value"});
			this.tableColumns = tableColumns;
		}
	}
}
